import React, { ReactElement } from 'react';

import { Button, Card, CardContent, CardHeader, CardActions, Modal, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const MainModal = styled(Modal)`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const ErrorCard = styled(Card)`
    width: 600px;
    padding: 16px 24px;
`;

const ErrorCardHeader = styled(CardHeader)`
`;

const ErrorCardActions = styled(CardActions)`
    display: flex;
    justify-content: right;
`;

const TryAgainMessage = styled(Typography)`
    margin-top: 20px;
`;

export interface ErrorModalProps {
    children: string | ReactElement<any, any>;
    open: boolean;
    onClose?: (event: React.MouseEvent<unknown>) => void;
    hideClose?: boolean;
    tryAgain?: boolean;
    title?: string;
    onTryAgain?: (event: React.MouseEvent<unknown>) => void;
}

const ErrorModal: React.FC<ErrorModalProps> = (props) => {
    const { t } = useTranslation('error_modal');

    return (
        <MainModal open={props.open} onClose={props.onClose}>
            <ErrorCard>
                <ErrorCardHeader title={props.title || t('oops')} />
                <CardContent>
                    <Typography variant="body1">{props.children}</Typography>
                    {props.tryAgain && <TryAgainMessage variant="body1">{t('please-try-again')}</TryAgainMessage>}
                </CardContent>
                <ErrorCardActions>
                    {!props.hideClose && <Button variant="outlined" onClick={props.onClose}>
                        {t('Close')}
                    </Button>}
                    {props.tryAgain && <Button color="primary" variant="contained" onClick={props.onTryAgain}>{t('try-again')}</Button>}
                </ErrorCardActions>
            </ErrorCard>
        </MainModal>
    );
};

export default ErrorModal;
